module.exports = __webpack_public_path__ + "static/img/8.5dd82b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/body/icon-2/8.png
// module id = 0lm3
// module chunks = 1